import { ComplianceApplicationStatus } from 'v2/types/api/settings'
import type { CallsPlacedType, NumberSeries } from './types'

export const STATUS_DISPLAY_MAP = {
  [ComplianceApplicationStatus.ACCEPTED]: { label: 'Approved', variant: 'success' },
  [ComplianceApplicationStatus.SUBMITTED]: { label: 'In review', variant: 'warning' },
  [ComplianceApplicationStatus.DRAFT]: { label: 'Draft', variant: 'default' },
  [ComplianceApplicationStatus.REJECTED]: { label: 'Rejected', variant: 'destructive' },
  [ComplianceApplicationStatus.EXPIRED]: { label: 'Expired', variant: 'destructive' },
  [ComplianceApplicationStatus.SUSPENDED]: { label: 'Suspended', variant: 'destructive' },
} as const

export const COMPLIANCE_COUNTRIES = ['IN'] as const

// TRAI 140/160 number series (India). The series is display-layer only: it is
// encoded in the alias prefix and number_type stays 'local' for the backend.
export const NUMBER_SERIES_ALIAS_PREFIX: Record<NumberSeries, string> = {
  '140': '140-',
  '160': '160-',
  other: '',
}

export interface NumberSeriesOption {
  value: NumberSeries
  title: string
  description: string
  isNew?: boolean
}

export const NUMBER_SERIES_OPTIONS: NumberSeriesOption[] = [
  {
    value: '140',
    title: '140-series',
    description: 'TRAI-regulated India number for promotional voice calls.',
    isNew: true,
  },
  {
    value: '160',
    title: '160-series',
    description: 'TRAI-regulated India number for BFSI transactional / service calls.',
    isNew: true,
  },
  {
    value: 'other',
    title: 'Other landline number (080 / 022)',
    description: 'Existing India landline compliance flow.',
  },
]

export const CALLS_PLACED_OPTIONS: {
  value: CallsPlacedType
  title: string
  description: string
}[] = [
  {
    value: 'self',
    title: 'Self-Managed',
    description: 'Your business places the calls itself (PE and TM are the same entity).',
  },
  {
    value: 'partner',
    title: 'Partner-Managed',
    description: 'A third party places calls on your behalf (PE and TM are different entities).',
  },
]

export const AGGREGATOR_TM_DECLARATION = 'Aggregator Telemarketer Declaration'
export const BFSI_CAF = 'BFSI Customer Application Form (CAF)'
// Second-document (GST slot) labels for the 140/160 series.
export const GST_CERT_TELEMARKETER = 'GST Certificate of Tele Marketer'
export const GST_CERT_PRINCIPAL_ENTITY = 'GST Certificate of Principal Entity'

// Worked examples of a correctly sealed and signed certificate, one per branch
// of the GST question, served from apps/web/public/samples. The link renders
// only while the matching entry is non-empty, so it can never point nowhere.
export const SAMPLE_DOCUMENT_URLS = {
  gst: '/samples/sample-gst-certificate.pdf',
  coi: '/samples/sample-coi.pdf',
  udyam: '/samples/sample-udyam.pdf',
} as const

// Blank form templates for the 140/160 declarations, downloaded, signed, and
// re-uploaded by the user. Links are hidden when empty.
export const DOWNLOAD_FORM_URLS: Record<string, string> = {
  [AGGREGATOR_TM_DECLARATION]:
    'https://www.plivo.com/downloads/Plivo_Aggregator_Telemarketer_Declaration.docx',
  [BFSI_CAF]: 'https://www.plivo.com/downloads/Plivo_BFSI_Customer_Application_Form.docx',
}
